import "./Modal.css"

import { createElement, Suspense, useEffect, useRef, useState } from "react"

import { IconButton, Loading } from "web/components"
import { getWindowWidth } from "web/services/browser"

export default function Modal({
  modalKey,
  onClose,
  title,
  fullScreen = true,
  noMargin = false,
  widthPixels,
  heightPixels,
  component,
  instancePromise,
  zIndex,
  message,
}) {
  const modalEl = useRef()

  const [isWaiting, setIsWaiting] = useState(false)

  useEffect(() => {
    if (!modalEl.current.contains(document.activeElement)) {
      modalEl.current.focus()
    }
  }, [])

  useEffect(() => {
    const { overflowY } = document.body.style
    document.body.style.overflowY = "hidden"

    return () => {
      document.body.style.overflowY = overflowY
    }
  }, [])

  function respond(response) {
    onClose(modalKey)
    instancePromise.resolve(response)
  }

  function close() {
    if (isWaiting === false) {
      respond(undefined)
    }
  }

  function handleKeyDown(event) {
    if (event.key === "Escape" && event.target === modalEl.current) {
      close()
    }
  }

  const screenIsSmall = getWindowWidth() <= 1000

  const windowStyle = {
    zIndex,
    ...(fullScreen || screenIsSmall
      ? {}
      : {
          width: `${widthPixels}px`,
          height: `${heightPixels}px`,
        }),
  }

  return (
    <div
      ref={modalEl}
      className="modal-window outline-none"
      style={windowStyle}
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className="modal-window-title-bar">
        <div className="modal-window-title overflow-hidden text-ellipsis whitespace-nowrap pr-6 text-lg font-bold text-neutral-3">
          {title}
          <div className="modal-window-close">
            <IconButton
              id="icon-close-modal-cross" // TODO: Replaced with IconButton can id can be removed?
              name="x-mark"
              data-testid="icon-close-modal-cross"
              onClick={close}
              width="25px"
              height="25px"
            />
          </div>
        </div>
      </div>
      <div className={`modal-window-content ${noMargin ? "no-margin" : ""}`}>
        <Loading inline={true} message={message} hidden={!isWaiting} />
        <Suspense fallback={null}>
          <div className={isWaiting ? "hidden" : "h-full"}>
            {createElement(component, {
              respond,
              close,
              onWaitingChanged: (v) => setIsWaiting(v),
            })}
          </div>
        </Suspense>
      </div>
    </div>
  )
}
